export const dashboardCardData = [
	{
		title: "Total Meeting Done",
		value: 50
	},
	{
		title: "Upcoming Meeting",
		value: 5
	},
	{
		title: "Current Meeting",
		value: 2
	},
	{
		title: "Recent Meeting",
		value: "29 October, 2019"
	}
];

export const dashTableData = [
	{
		title: "Mid-term Exam Meeting",
		duration: "None",
		participants: 10,
		date: "5.00 pm - 10 Nov 2019"
	},
	{
		title: "Final Exam Meeting",
		duration: "None",
		participants: 15,
		date: "5.00 pm - 14 Dec 2019"
	},
	{
		title: "Sudden Meeting",
		duration: "None",
		participants: 7,
		date: "5.00 pm - 19 July 2019"
	},
	{
		title: "Improvement Meeting",
		duration: "None",
		participants: 18,
		date: "5.00 pm - 14 June 2019"
	},
	{
		title: "Sudden Meeting",
		duration: "None",
		participants: 15,
		date: "5.00 pm - 04 July 2019"
	}
];
